import { Suspense } from 'react'

import { ErrorBoundary } from 'react-error-boundary'

import PopularSearchesList, { PopularSearchesLoading } from './popular-searches-list'

import styles from './popular-searches.module.scss'
import { Country } from '@types'

export default function PopularSearches({ close, locale }: { close: () => void; locale: Country }): JSX.Element {
  return (
    <div className={styles['popular-searches']}>
      <h3>Popular Searches</h3>
      <div className={styles.wrap}>
        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<PopularSearchesLoading />}>
            <PopularSearchesList onClick={close} locale={locale} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  )
}
